import {
    CREATE_COMMENT,
    SET_ERROR,
    CLEAR_STATE,
    GET_COMMENTS,
    SET_LOADING,
    GET_COMMENT,
    UPDATE_COMMENT,
    CLEAR_COMMENT,
    UPDATE_CALENDAR,
} from '../types';

export default (state, action) => {
    switch (action.type) {
        case UPDATE_CALENDAR:
            const { oldTask, newTask } = action.payload;

            let calendarTasks = state.comments;

            if (oldTask)
                calendarTasks = calendarTasks.filter(
                    (task) => task._id.toString() !== oldTask.toString()
                );

            if (newTask) calendarTasks.push(newTask);

            return {
                ...state,
                comments: calendarTasks,
                loading: false,
                error: null,
            };
        case CLEAR_COMMENT:
            return {
                ...state,
                comment: null,
                loading: false,
                error: null,
            };
        case UPDATE_COMMENT:
            let updatedComments = [];
            if (!action.payload.pending) {
                updatedComments = state.comments.map(
                    (x) => x._id !== action.payload._id
                );
            } else {
                updatedComments = state.comments;
            }
            return {
                ...state,
                comments: updatedComments,
                loading: false,
            };
        case GET_COMMENT:
            return {
                ...state,
                loading: false,
                comment: action.payload,
            };
        case GET_COMMENTS:
            return {
                ...state,
                comments: action.payload,
                count: action.count,
                loading: false,
                error: null,
            };
        case CREATE_COMMENT:
            return {
                ...state,
                comments: [action.payload, ...state.comments],
                loading: false,
            };
        case SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        case CLEAR_STATE:
            return {
                ...state,
                comments: [],
                comment: {},
                error: null,
                loading: false,
            };
        case SET_LOADING:
            return {
                ...state,
                loading: true,
            };
        default:
            return state;
    }
};
